// extracted by mini-css-extract-plugin
export default {"box":"Packages_box__nVhJY","title":"Packages_title__BXfty"};